import React, { useEffect, useRef, useState } from "react";
import backicon from "./../../../../../Assets/icons/backIcon.svg";
import editIcon from "./../../../../../Assets/icons/Un-Checkbox.svg";
import deleteIcon from "./../../../../../Assets/icons/trash.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import axiosInstance from "../../../../services/api/API";
import Loader from "../../../../customComponents/CustomLoader";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import { showAlert } from "../../../../customComponents/CustomSweetAlert/ShowAlert";
import * as base64 from "base-64";
import CustomTable from "../../../../customComponents/CustomTable";

const SoldAddPurchaseOrder = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [dealerOptions, setDealerOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [itemNameOptions, setItemNameOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [paymentTypeVal, setPaymnentTypeVal] = useState([]);
  const [financerVal, setFinancerVal] = useState([]);
  const [paymentModeVal, setPaymentModeVal] = useState([]);

  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [batteryOptions, setBatteryOptions] = useState([]);

  const [firstBatteryNameOption, setFirstBatteryNameOption] = useState();

  const [selectedVariant, setSelectedVariant] = useState(null);

  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const [roledd, setRoledd] = useState([]);
  const [vinOptions, setVinOptions] = useState([]);

  const [batteryName, setBatteryNameOptions] = useState([]);
  const [batteryNumbers, setBatteryNumbersOptions] = useState([]);

  const [serialNoOptions, setSerialOptions] = useState([]);

  const [customerId, setCustomerId] = useState();

  const initialBasePriceRef = useRef(null);

  // useEffect(() => {
  //   if (formData.variant && variantOptions.length > 0) {
  //     const selected = variantOptions.find((v) => v.value === formData.variant);
  //     if (selected) {
  //       fetchPaymentTypeVal(selected.is_finance_available);
  //     }
  //   }
  // }, [formData.variant, variantOptions]);

  useEffect(() => {
    if (
      formData.baseprice !== undefined &&
      formData.baseprice !== null &&
      initialBasePriceRef.current === null
    ) {
      initialBasePriceRef.current = formData.baseprice;
      console.log("Initial base price set to:", formData.baseprice);
    }
  }, [formData.baseprice]);

  const userType = localStorage.getItem("UserType");
  console.log(userType, "USERTYPE");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const dealer_id = localStorage.getItem("dealerId");

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    roleDropdown();
  }, []);

  const roleDropdown = async () => {
    try {
      const payload = {
        business_partner_id:
          userType === "superadmin"
            ? formData?.business_partner_id
            : businessPartnerId,
      };

      const response = await axiosInstance.post("/role/ddlrole", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const roleOptions = data.map((role) => ({
        value: role.ID,
        label: role.NAME,
      }));
      setRoledd(roleOptions);
    } catch (error) {
      console.log(error);
    }
  };

  // const handleFormSubmit = async (formData) => {
  //   console.log("dealerformdata",formData);

  //   const errors = {};
  //   let isValid = true;

  //   DealerInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       } else if (
  //         field.validation.pattern &&
  //         !field.validation.pattern.test(formData[field.name])
  //       ) {
  //         errors[field.name] = field.validation.message;
  //         isValid = false;
  //       }
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you want to add this record?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {

  //         // Map postockinsr_id back to vin_no
  //       const selectedVinOption = vinOptions.find(
  //         (option) => option.value === formData.vin_no
  //       );

  //         setLoading(true);
  //         const payload = {
  //           full_name: formData.full_name,
  //           email_id: formData.email_id,
  //           mobile_no: formData.mobile_no,
  //           address: formData.address,
  //           email_id: formData.email_id,
  //           customer_delivery_date: formData.customer_delivery_date,
  //           // vin_no: formData.vin_no,
  //           vin_no: selectedVinOption?.label,
  //           country_id: formData.country_id,
  //           state_id: formData.state_id,
  //           city_id: formData.city_id,
  //           pincode: formData.pincode,
  //           dealer_id:dealer_id,
  //           discount:"0",
  //           discount_type:"0",
  //           // color_id:formData.color_id,
  //           // total_price:formData.totalamount,
  //           total_price: formData.totalamount,
  //           total_cus_basic_price:formData.baseprice.toString(),
  //           cust_tax: formData.tax_percent,
  //           cust_tax_amnt:formData.taxamount.toString(),
  //           remark:formData.remark
  //         };

  //         // API call to create a dealer
  //         const response = await axiosInstance.post('/customer-po/create', payload, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${authToken}`,
  //           },
  //         });

  //         if (response.status === 200) {
  //           navigate("/sales/manage-customer-purchase-order/purchase-order")
  //           setFormData({})
  //         }

  //       } catch (error) {

  //         console.error('Error adding record:', error);
  //         const errorMessage = error.response?.data?.message;
  //         console.log(errorMessage, "errorMessage")
  //         Swal.fire({
  //           title: "Error",
  //           text: errorMessage,
  //           icon: "error",
  //           confirmButtonText: "OK",
  //         });
  //       } finally {

  //         setLoading(false);
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {

  //       Swal.fire({
  //         title: "Cancelled",
  //         text: "The record was not added.",
  //         icon: "info",
  //         confirmButtonText: "OK",
  //       });

  //       setLoading(false);
  //     }
  //   });
  // };

  const handleFormSubmit = async (formData) => {
    console.log("dealerformdata", formData);

    const errors = {};
    let isValid = true;

    // const allInputs = [...DealerInputs, ...FinanceInputs];

    DealerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const actualDealerId = formData?.select_dealer || dealer_id;
          const payload = {
            dealer_id: actualDealerId,
            full_name: formData.full_name,
            email_id: formData.email_id,
            mobile_no: formData.mobile_no,
            address: formData.address,
            email_id: formData.email_id,
            customer_delivery_date: formData.customer_delivery_date,
            // vin_no: selectedVinOption?.label,
            // vin_no: selectedVinOption?.label,
            // remark:formData?.remark,
            // customer_purchase_data: formData?.customer_purchase_data || "",
            remark: formData?.remark || "",
            country_id: formData.country_id,
            state_id: formData.state_id,
            city_id: formData.city_id,
            pincode: formData.pincode,
            // dealer_id: formData?.select_dealer,
            itemType: formData?.itemType,
            // model: formData?.model,
            color_id: formData?.color_id,
            variant_id: formData?.variant,
            // accessory: formData?.accessory,
            vin_no: formData?.vin_no,
            battery_id: formData?.battery_name,
            // battery_no: formData?.battery_no,
            // battery_name: formData?.battery_no ? [formData.battery_no] : [],
            battery_name: formData?.battery_no
              ? formData.battery_no
                  .split(",")
                  .map((item) => item.trim())
                  .filter(Boolean)
              : [],
            motor_no: formData?.motor_no,
            controller_no: formData?.controller_no,
            status: 1,
          };

          const response = await axiosInstance.patch(
            `/instock/accept-instock-dealer-customer-quantity/${actualDealerId}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          const fetchedData = response?.data?.data;
          const customerIdVal = fetchedData?.postockinsr_id;

          if (response.status === 200) {
            navigate("/sales/manage-product/customer-stock-in");
            // handleMailFunc(customerIdVal); // pass ID directly here
            setFormData({});
          }
          if (response.status === 400) {
            console.error("Error adding record:", response?.data);
            const errorMessage = response?.data;
            Swal.fire({
              title: "Error",
              text: errorMessage,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error adding record:", error);

          const errorData = error.response?.data?.message;

          // Extract error message properly
          const errorMessage =
            errorData?.data?.message ||
            (typeof errorData === "string"
              ? errorData
              : "Something went wrong");

          Swal.fire({
            title: "Error",
            text: errorData || "Error Adding Record ",
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "The record was not added.",
          icon: "info",
          confirmButtonText: "OK",
        });

        setLoading(false);
      }
    });
  };

  // const handleFormSave = async (formData) => {
  //   const errors = {};
  //   let isValid = true;

  //   ItemInputs.forEach((field) => {
  //     const value = formData[field.name];

  //     if (field.validation?.required && !value) {
  //       errors[field.name] = "This field is required";
  //       isValid = false;
  //       return;
  //     }

  //     if (
  //       value &&
  //       field.validation?.pattern &&
  //       !field.validation.pattern.test(value)
  //     ) {
  //       errors[field.name] = field.validation.message;
  //       isValid = false;
  //       return;
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   if (
  //     initialBasePriceRef.current !== null &&
  //     formData.baseprice !== initialBasePriceRef.current
  //   ) {
  //     console.log("clicked");
  //   }

  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you want to add this record?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {

  //         let selectedVinOption;
  //         let batteryNumberLabels = [];

  //         if (formData.itemType === "V") {
  //           selectedVinOption = vinOptions.find(
  //             (option) => option.value === formData.vin_no,
  //           );
  //         } else if (formData.itemType === "A" || formData.itemType === "S") {
  //           selectedVinOption = serialNoOptions.find(
  //             (option) => option.value === formData.vin_no,
  //           );
  //         }

  //         if (Array.isArray(formData.battery_no)) {
  //           batteryNumberLabels = batteryNumbers
  //             .filter((option) => formData.battery_no.includes(option.value))
  //             .map((option) => option.label);
  //         }

  //         setLoading(true);
  //         const payload = {
  //           vin_no: selectedVinOption?.label,
  //           battery_id: formData?.battery_name,
  //           battery_no: batteryNumberLabels,
  //           item_type: formData?.itemType,
  //         };

  //         const response = await axiosInstance.post(
  //           "/customer-po/draft",
  //           payload,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${authToken}`,
  //             },
  //           },
  //         );

  //         // const fetchedData = response?.data?.data;
  //         // const customerIdVal = fetchedData?.postockinsr_id;
  //         // console.log(customerIdVal, "custidVal")
  //         // setCustomerId(customerIdVal)

  //         // if (response.status === 200) {
  //         //   navigate("/sales/manage-customer-purchase-order/purchase-order");
  //         //   handleMailFunc()
  //         //   setFormData({});
  //         // }

  //         if (response.status === 200) {
  //           // navigate("/sales/manage-customer-purchase-order/purchase-order");
  //           // handleMailFunc(customerIdVal); // pass ID directly here
  //           // setFormData({});
  //           fetchTableList();
  //           setFormData((prev) => ({ ...prev, ...clearItemFields() }));
  //         }
  //         // if (response.status === 400) {
  //         //   console.error("Error adding record:", error?.response?.data?.data);
  //         //   const errorMessage = response?.data;
  //         //   Swal.fire({
  //         //     title: "Error",
  //         //     text: errorMessage,
  //         //     icon: "error",
  //         //     confirmButtonText: "OK",
  //         //   });
  //         // }
  //       } catch (error) {
  //         console.error(
  //           "Error adding record:",
  //           error?.response?.data?.data[0]?.message,
  //         );

  //         const errorData = error?.response?.data?.data[0]?.message;

  //         // Extract error message properly
  //         const errorMessage =
  //           errorData?.data?.message ||
  //           (typeof errorData === "string"
  //             ? errorData
  //             : "Something went wrong");

  //         Swal.fire({
  //           title: "Error",
  //           text: errorMessage,
  //           icon: "error",
  //           confirmButtonText: "OK",
  //         });
  //       } finally {
  //         setLoading(false);
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire({
  //         title: "Cancelled",
  //         text: "The record was not added.",
  //         icon: "info",
  //         confirmButtonText: "OK",
  //       });

  //       setLoading(false);
  //     }
  //   });
  // };

  const handleFormSave = async (formData) => {
    const errors = {};
    let isValid = true;

    // 🔹 Basic Field Validation
    ItemInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    // 🔥 Battery Type Validation Logic
    if (formData.itemType === "V") {
      const selectedBattery = batteryName.find(
        (b) => b.value === formData.battery_name,
      );

      const selectedBatteryType = selectedBattery?.batteryType;
      const selectedBatteryCount = formData.battery_no?.length || 0;
  
      // Graphene → Minimum 4
      if (selectedBatteryType === "G" && selectedBatteryCount != 5) {
        Swal.fire({
          title: "Invalid Selection",
          text: "Graphene Battery requires at least 5 battery numbers.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }

      // Lithium → Maximum 1
      if (selectedBatteryType === "L" && selectedBatteryCount != 1) {
        Swal.fire({
          title: "Invalid Selection",
          text: "Lithium Battery allows only 1 battery number.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }
    }

    // 🔹 Base Price Change Check (Your Existing Logic)
    if (
      initialBasePriceRef.current !== null &&
      formData.baseprice !== initialBasePriceRef.current
    ) {
      console.log("Base price changed");
    }

    // 🔔 Confirmation Modal
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let selectedVinOption;
          let batteryNumberLabels = [];

          // 🔹 VIN Selection
          if (formData.itemType === "V") {
            selectedVinOption = vinOptions.find(
              (option) => option.value === formData.vin_no,
            );
          } else if (formData.itemType === "A" || formData.itemType === "S") {
            selectedVinOption = serialNoOptions.find(
              (option) => option.value === formData.vin_no,
            );
          }

          // 🔹 Convert Battery IDs → Labels
          if (Array.isArray(formData.battery_no)) {
            batteryNumberLabels = batteryNumbers
              .filter((option) => formData.battery_no.includes(option.value))
              .map((option) => option.label);
          }

          setLoading(true);

          const payload = {
            vin_no: selectedVinOption?.label,
            battery_id: formData?.battery_name,
            battery_no: batteryNumberLabels,
            item_type: formData?.itemType,
          };

          const response = await axiosInstance.post(
            "/customer-po/draft",
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Record added successfully.",
              icon: "success",
              confirmButtonText: "OK",
            });

            fetchTableList();

            // Clear only item fields
            setFormData((prev) => ({
              ...prev,
              ...clearItemFields(),
            }));
          }
        } catch (error) {
          console.error(
            "Error adding record:",
            error?.response?.data?.data?.[0]?.message,
          );

          const errorData = error?.response?.data?.data?.[0]?.message;

          const errorMessage =
            errorData?.data?.message ||
            (typeof errorData === "string"
              ? errorData
              : "Something went wrong");

          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "The record was not added.",
          icon: "info",
          confirmButtonText: "OK",
        });

        setLoading(false);
      }
    });
  };

  const ItemInputs = [
    {
      name: "itemType",
      label: "Item Type",
      placeholder: "Enter",
      type: "dropdown",
      options: [
        { value: "V", label: "Vehicle" },
        // { value: "A", label: "Accessories" },
        { value: "S", label: "Spare Part" },
      ],
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "model",
      label: "Model",
      type: "dropdown",
      options: modelOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "color_id",
      label: "Color",
      placeholder: "Color",
      type: "dropdown",
      options: colorOptions,
      // disabled:true,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    // {
    //   name: "variant",
    //   label: "Variant",
    //   placeholder: "",
    //   type: "dropdown",
    //   options: variantOptions,
    //   required: true,
    //   gridClass: "col-lg-4",
    // },
    ...(formData.itemType === "V"
      ? [
          {
            name: "variant",
            label: "Variant",
            placeholder: "",
            type: "dropdown",
            options: variantOptions,
            required: true,
            gridClass: "col-lg-4",
          },
        ]
      : []),
    ...(formData.itemType !== "V"
      ? [
          {
            name: "accessory",
            label: "Item Name",
            placeholder: "",
            type: "dropdown",
            options: itemNameOptions,
            required: true,
            gridClass: "col-lg-4",
            validation: { required: true },
          },
        ]
      : []),
    ...(formData.itemType === "V"
      ? [
          {
            name: "vin_no",
            label: "Vin No. / Serial No.",
            type: "text",
            placeholder: "Enter Vin/Serial No.",
            // options: vinOptions,
            validation: { required: true },
            required: true,
            // serialNoOptions
            gridClass: "col-lg-4",
          },
        ]
      : []),

    ...(formData.itemType !== "V"
      ? [
          {
            name: "vin_no",
            label: "Serial No.",
            type: "text",
            placeholder: "Serial No.",
            // options: serialNoOptions,
            validation: {
              required: true,
            },
            required: true,
            // serialNoOptions
            gridClass: "col-lg-4",
          },
        ]
      : []),
    ...(formData.itemType === "V"
      ? [
          {
            name: "battery_name",
            label: "Battery Name",
            type: "dropdown",
            placeholder: "",
            options: batteryOptions,
            validation: {
              required: true,
            },
            required: true,
            // serialNoOptions
            gridClass: "col-lg-4",
          },
        ]
      : []),
    ...(formData.itemType === "V"
      ? [
          {
            name: "battery_no",
            label: "Battery No.",
            type: "text",
            placeholder: "Enter Battery No.",
            // options: batteryNumbers,
            required: true,
            validation: { required: true },
            // serialNoOptions
            gridClass: "col-lg-4",
          },
          {
            name: "motor_no",
            label: "Motor No.",
            type: "text",
            placeholder: "Enter Motor No.",
            // options: batteryNumbers,
            required: true,
            validation: { required: true },
            // serialNoOptions
            gridClass: "col-lg-4",
          },
          {
            name: "controller_no",
            label: "Controller No.",
            type: "text",
            placeholder: "Enter Controller No.",
            // options: batteryNumbers,
            required: true,
            validation: { required: true },
            // serialNoOptions
            gridClass: "col-lg-4",
          },
        ]
      : []),
  ];

  const clearItemFields = () => ({
    itemType: "",
    model: "",
    color_id: "",
    variant: "",
    accessory: "",
    vin_no: "",
    battery_name: "",
    battery_no: [],
  });

  const FinanceInputs = [
    // {
    //   name: "baseprice",
    //   label: "₹ Base Price",
    //   placeholder: "Enter Base Price",
    //   type: "text",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    //   //  disabled:true
    // },
    // {
    //   name: "tax_percent",
    //   label: "GST Percent",
    //   placeholder: "Enter Tax Percent",
    //   type: "text",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    //   disabled: true,
    // },
    {
      name: "taxamount",
      label: "₹ GST Amount",
      placeholder: "Enter Tax Percent",
      type: "text",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    // {
    //   name: "discount_type",
    //   label: "Discount Type",
    //   placeholder:"Enter ",
    //   type: "dropdown",
    //   options:[
    //       { value: "A", label: "Amount" },
    //       { value: "P", label: "Percentage" }
    //     ],
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true,
    //   },
    // },
    // {
    //   name: "discount",
    //   label: "Discount",
    //   placeholder:"Enter Discount",
    //   type: "text",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true,
    //    },
    // },
    {
      name: "customer_delivery_date",
      label: "Customer Delivery Date",
      type: "date",
      placeholder: "Enter GST No.",
      validation: { required: true },
      gridClass: "col-lg-4",
      minDate: new Date(),
    },
    {
      name: "totalamount",
      label: "₹ Total Amount",
      placeholder: "Enter total amount",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      disabled: true,
    },
    {
      name: "payment_type",
      label: "Payment Type",
      placeholder: "Enter ",
      type: "dropdown",
      options: paymentTypeVal,
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "downPayment",
      label: "₹ Down Payment",
      placeholder: "Enter Down Payment",
      type: "number",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: formData?.payment_type === 2 ? true : false,
    },
    {
      name: "financeAmt",
      label: "₹ Balance Amount",
      placeholder: "Enter Finance Amount",
      type: "number",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true,
      //  },
      disabled: true,
    },
    {
      name: "payment_mode",
      label: "Payment Mode",
      type: "dropdown",
      options: paymentModeVal,
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    ...(formData.payment_type !== 2
      ? [
          {
            name: "no_of_month",
            label: "No. Of Months",
            placeholder: "Enter no. of months",
            type: "text",
            // required: true,
            gridClass: "col-lg-4",
            // validation: { required: true },
            //  disabled:true
          },
        ]
      : []),
    ...(formData.payment_mode !== 1
      ? [
          {
            name: "finance_bank",
            label: "Finance",
            placeholder: "Enter Finance",
            type: "dropdown",
            options: financerVal,
            required: true,
            gridClass: "col-lg-4",
            validation: { required: true },
            //  disabled:true
          },
        ]
      : []),
    // {
    //   name: "finance_bank",
    //   label: "Finance",
    //   placeholder:"Enter Finance",
    //   type: "dropdown",
    //   options:financerVal,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true,
    //    },
    //   //  disabled:true
    // },
    // {
    //   name: "payment_mode",
    //   label: "Payment Mode",
    //   type: "dropdown",
    //   options:paymentModeVal,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true,
    //   },
    //   //  disabled:true
    // },
    // {
    //   name: "no_of_month",
    //   label: "No. Of Months",
    //   placeholder:"Enter no. of months",
    //   type: "text",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true,
    //    },
    //   //  disabled:true
    // },

    // ...(formData.payment_type !== 2
    //   ? [

    //       ...(formData.payment_type !== 3
    //         ? [
    //             {
    //               name: "no_of_month",
    //               label: "No. Of Months",
    //               placeholder: "Enter no. of months",
    //               type: "text",
    //               required: true,
    //               gridClass: "col-lg-4",
    //               validation: { required: true },
    //               //  disabled:true
    //             },
    //           ]
    //         : []),
    //       ...(formData.payment_mode !== 1
    //         ? [
    //             {
    //               name: "finance_bank",
    //               label: "Finance",
    //               placeholder: "Enter Finance",
    //               type: "dropdown",
    //               options: financerVal,
    //               required: true,
    //               gridClass: "col-lg-4",
    //               validation: { required: true },
    //               //  disabled:true
    //             },
    //           ]
    //         : []),
    //     ]
    //   : []),

    {
      name: "remark",
      label: "Remark",
      placeholder: "Enter Remark",
      type: "text",
      required: false,
      gridClass: "col-lg-4",
      // validation: { required: true},
      //  disabled:true
    },
    //  {
    //   name: "rsa",
    //   label: "RSA",
    //   type: "checkbox",
    //   required: true,
    //   // validation: { required: true },
    //   getValue: (value) => (value ? 1 : 0),
    //   gridClass: "col-lg-8",
    // },
    // {
    //   name: "motor_insurance",
    //   label: "Motor Insurance",
    //   type: "checkbox",
    //   // required: true,
    //   // validation: { required: true },
    //   getValue: (value) => (value ? 1 : 0),
    //   gridClass: "col-lg-2",
    // },
  ];

  // const RSAInputs = [
  //   {
  //     name: "rsa",
  //     label: "RSA( Road Side Accident)",
  //     type: "checkbox",
  //     required: true,
  //     // validation: { required: true },
  //     getValue: (value) => (value ? 1 : 0),
  //     gridClass: "col-lg-3",
  //   },
  //   {
  //     name: "motor_insurance",
  //     label: "Motor Insurance",
  //     type: "checkbox",
  //     // required: true,
  //     // validation: { required: true },
  //     getValue: (value) => (value ? 1 : 0),
  //     gridClass: "col-lg-3",
  //   },
  // ];

  const DealerInputs = [
    ...(userType === "businesspartner"
      ? [
          {
            name: "select_dealer",
            label: "Select Dealer",
            placeholder: "Select Dealer",
            type: "dropdown",
            options: dealerOptions,
            required: true,
            gridClass: "col-lg-4",
            validation: { required: true },
          },
        ]
      : []),
    {
      name: "full_name",
      label: "Customer Name",
      placeholder: "Enter Customer Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
        maxLength: 20,
      },
    },

    {
      name: "mobile_no",
      label: "Mobile No.",
      placeholder: "Enter Mobile No.",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[6-9]/,
        minLength: 10,
        maxLength: 10,
        message1: "Contact No. should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit Contact No.",
      },
    },
    {
      name: "email_id",
      label: "Email ID",
      placeholder: "Enter Email Address",
      type: "text",
      // required: true,
      gridClass: "col-lg-4",
      validation: {
        // required: true,
        // pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        // maxLength: 45,
        // message: "Please enter a valid Email Address",
      },
    },
    {
      name: "address",
      label: "Address",
      placeholder: "Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[a-zA-Z0-9 ,&-]{10,70}$/,
        minLength: 10,
        maxLength: 70,
        message:
          "Address should be 10–70 characters and can contain letters, numbers, spaces, -, , & only",
      },
    },
    {
      name: "pan",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter Pan No.",
      validation: {
        // required: true,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "PAN must be valid 10 characters in uppercase",
        maxLength: 10,
      },
      // required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, maxLength: 6 },
    },
    {
      name: "city",
      label: "City",
      placeholder: "City",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "state",
      label: "State",
      placeholder: "State",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Country",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      placeholder: "Enter Remark",
      // options: batteryNumbers,
      // required: true,
      // validation: { required: true },
      // serialNoOptions
      gridClass: "col-lg-4",
    },
    {
      name: "customer_delivery_date",
      label: "Customer Purchase Date",
      type: "date",
      maxDate: new Date(),
      placeholder: "Enter Customer Purchase Data",
      // options: batteryNumbers,
      // required: true,
      // validation: { required: true },
      // serialNoOptions
      gridClass: "col-lg-4",
      required: true,
      validation: { required: true },
    },
    {
      name: "itemType",
      label: "Item Type",
      placeholder: "Enter",
      type: "dropdown",
      options: [
        { value: "V", label: "Vehicle" },
        // { value: "A", label: "Accessories" },
        // { value: "S", label: "Spare Part" },
      ],
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      required: true,
      validation: { required: true },
    },
    {
      name: "model",
      label: "Model",
      type: "dropdown",
      options: modelOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "color_id",
      label: "Color",
      placeholder: "Color",
      type: "dropdown",
      options: colorOptions,
      // disabled:true,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    // {
    //   name: "variant",
    //   label: "Variant",
    //   placeholder: "",
    //   type: "dropdown",
    //   options: variantOptions,
    //   required: true,
    //   gridClass: "col-lg-4",
    // },
    ...(formData.itemType === "V"
      ? [
          {
            name: "variant",
            label: "Variant",
            placeholder: "",
            type: "dropdown",
            options: variantOptions,
            required: true,
            gridClass: "col-lg-4",
            // required: true,
            validation: { required: true },
          },
        ]
      : []),
    ...(formData.itemType !== "V"
      ? [
          {
            name: "accessory",
            label: "Item Name",
            placeholder: "",
            type: "dropdown",
            options: itemNameOptions,
            // required: true,
            gridClass: "col-lg-4",
            // validation: { required: true },
          },
        ]
      : []),
    ...(formData.itemType === "V"
      ? [
          {
            name: "vin_no",
            label: "Vin No. / Serial No.",
            type: "text",
            placeholder: "Enter Vin/Serial No.",
            // options: vinOptions,
            validation: { required: true },
            required: true,
            // serialNoOptions
            gridClass: "col-lg-4",
          },
        ]
      : []),

    ...(formData.itemType !== "V"
      ? [
          {
            name: "vin_no",
            label: "Serial No.",
            type: "text",
            placeholder: "Serial No.",
            // options: serialNoOptions,
            validation: {
              // required: true,
            },
            // required: true,
            // serialNoOptions
            gridClass: "col-lg-4",
          },
        ]
      : []),
    ...(formData.itemType === "V"
      ? [
          {
            name: "battery_name",
            label: "Battery Name",
            type: "dropdown",
            placeholder: "",
            options: batteryOptions,
            validation: {
              required: true,
            },
            required: true,
            // serialNoOptions
            gridClass: "col-lg-4",
          },
        ]
      : []),
    ...(formData.itemType === "V"
      ? [
          {
            name: "battery_no",
            label: "Battery No.",
            type: "text",
            placeholder: "Enter Battery No.",
            // options: batteryNumbers,
            required: true,
            validation: { required: true },
            // serialNoOptions
            gridClass: "col-lg-4",
          },
          {
            name: "motor_no",
            label: "Motor No.",
            type: "text",
            placeholder: "Enter Motor No.",
            // options: batteryNumbers,
            required: true,
            validation: { required: true },
            // serialNoOptions
            gridClass: "col-lg-4",
          },
          {
            name: "controller_no",
            label: "Controller No.",
            type: "text",
            placeholder: "Enter Controller No.",
            // options: batteryNumbers,
            required: true,
            validation: { required: true },
            // serialNoOptions
            gridClass: "col-lg-4",
          },
          // customer_purchase_data
          // remark
        ]
      : []),
  ];

  useEffect(() => {
    const itemTypeVal = formData.itemType;

    if (itemTypeVal) {
      fetchModelOptions(itemTypeVal);
    }
  }, [formData.itemType]);

  const fetchModelOptions = async (itemTypeVal) => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
        itemType: itemTypeVal,
      };

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    const modelId = formData.model;

    if (modelId) {
      fetchColorOptions(modelId);
    }
  }, [formData.model]);

  const fetchColorOptions = async (modelId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        model_id: modelId,
      };

      const response = await axiosInstance.post("/color/ddlcolor", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  const fetchPaymentModeVal = async () => {
    try {
      const payload = {};

      const response = await axiosInstance.post("/paymentmode/list", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.map((color) => ({
        label: color.payment_mode,
        value: color.payment_mode_id,
      }));

      setPaymentModeVal(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    fetchPaymentModeVal();
  }, []);

  const fetchFinancerVal = async () => {
    try {
      const payload = {};

      const response = await axiosInstance.post("/financer/ddl", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setFinancerVal(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    fetchFinancerVal();
  }, []);

  const fetchPaymentTypeVal = async (isFinanceAvailable) => {
    try {
      const payload = {
        is_finance_available: isFinanceAvailable,
      };

      const response = await axiosInstance.post("/paymenttype/list", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.map((color) => ({
        label: color.payment_type,
        value: color.id,
      }));

      setPaymnentTypeVal(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    fetchPaymentTypeVal();
  }, []);

  useEffect(() => {
    const colorId = formData.color_id;
    const modelId = formData.model;
    const dealerDropdown = formData.dealer_id;

    if (colorId && modelId && formData.itemType === "V") {
      fetchVariantOptions(colorId, modelId, dealerDropdown);
    }
  }, [formData.color_id, formData.model, formData.itemType, formData.select_dealer]);

  const fetchVariantOptions = async (colorId, modelId, dealerDropdown) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          color_id: colorId,
          dealer_id: dealerDropdown,
          model_id: modelId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
        // is_finance_available: variant.is_finance_available,
        // baterytId: variant?.batteryId,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  // useEffect(() => {
  //   const colorId = formData.color_id;
  //   const modelId = formData.model;
  //   const itemTypeVal = formData.itemType

  //   if (
  //     colorId &&
  //     modelId &&
  //     (formData.itemType === "A" || formData.itemType === "S")
  //   ) {
  //     fetchItemOptions(colorId, modelId, itemTypeVal );
  //   }
  // }, [formData.color_id, formData.model, formData.itemType]);

  useEffect(() => {
    const colorId = formData.color_id;
    const modelId = formData.model;
    const itemTypeVal = formData.itemType;

    // Condition 1: Only when itemType is A or S (called once regardless of color/model)
    if (itemTypeVal === "A" || itemTypeVal === "S") {
      fetchItemOptions(colorId || 0, modelId || 0, itemTypeVal); // Pass nulls if not available
    }

    // Condition 2: When colorId and modelId are also present with valid itemType
    if (colorId && modelId && (itemTypeVal === "A" || itemTypeVal === "S")) {
      fetchItemOptions(colorId, modelId, itemTypeVal);
    }
  }, [formData.color_id, formData.model, formData.itemType]);

  const fetchItemOptions = async (colorId, modelId, itemTypeVal) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/item/getitem",
        {
          color_id: colorId || 0,
          model_id: modelId || 0,
          itemType: itemTypeVal,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
        is_finance_available: variant.is_finance_available,
      }));
      setItemNameOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  //   useEffect(() => {
  //   const variantId = formData.variant;
  //   const accessoryId = formData.accessory;

  //   if (variantId) {
  //     fetchVinOptions(variantId);
  //   } else if (accessoryId) {
  //     fetchVinOptions(accessoryId);
  //   }
  // }, [formData.variant, formData.accessory]);

  useEffect(() => {
    const accessoryId = formData.accessory;
    const itemType = formData?.itemType;

    if (accessoryId && itemType) {
      fetchSerialNoOptions(accessoryId, itemType);
    }
  }, [formData.accessory, formData.itemType]);

  const fetchSerialNoOptions = async (accessoryId, itemType) => {
    try {
      const payload = {
        dealer_id: dealer_id,
        item_id: accessoryId,
        itemType: itemType,
      };

      const response = await axiosInstance.post(
        "/sales/ser-num-list",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((model) => ({
        label: model.serial_no,
        value: model.postockinsr_id,
      }));

      setSerialOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    const variantId = formData.variant;
    const dealerDropdown = formData?.select_dealer;

    if (variantId) {
      fetchVinOptions(variantId, dealerDropdown);
    }
  }, [formData.variant ,formData?.select_dealer]);

  const fetchVinOptions = async (variantId, dealerDropdown) => {
    try {
      const payload = {
        dealer_id: dealerDropdown,
        variant_id: variantId,
      };

      const response = await axiosInstance.post(
        "/sales/vin-num-list",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((model) => ({
        label: model.vin_no,
        value: model.postockinsr_id,
      }));

      setVinOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  // useEffect(() => {
  //   // const batteryId = formData.variant.batteryId
  //   // console.log(batteryId, "batteryId")
  //   console.log(formData?.variant, "variantOptions")

  //   if(formData?.variant){
  //     fetchBatteryName(formData.variant.batteryId);
  //   }
  // }, [formData?.variant]);

  useEffect(() => {
    const dealerDropdown = formData?.select_dealer || dealer_id;
    if (formData.variant && variantOptions.length > 0) {
      const selected = variantOptions.find((v) => v.value === formData.variant);
      if (selected) {
        fetchBatteryName(selected.batteryId, dealerDropdown);
      }
    }
  }, [formData.variant, variantOptions, formData?.select_dealer, dealer_id]);

  useEffect(() => {
    // setFormData({
    //   battery_name: firstBatteryNameOption
    // })

    if (firstBatteryNameOption !== undefined) {
      setFormData((prevData) => ({
        ...prevData,
        battery_name: firstBatteryNameOption,
      }));
    }
  }, [firstBatteryNameOption]);

useEffect(() => {
  const dealerDropdown = formData?.select_dealer || dealer_id;
  if (dealerDropdown) {
    fetchBatteryOptions(dealerDropdown);
  }
}, [formData?.select_dealer, dealer_id]);

  // const fetchBatteryOptions = async (dealerDropdown) => {
  //   try {
  //     const response = await axiosInstance.get(
  //       "/battery/battery-ddl-purchaseOrder",
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       },
  //     );

  //     const options = response.data.data.data.map((battery) => ({
  //       label: battery.NAME,
  //       value: battery.ID,
  //     }));

  //     setBatteryOptions(options);
  //   } catch (error) {
  //     console.error("Error fetching model options:", error);
  //   }
  // };

  const fetchBatteryOptions = async (dealerDropdown) => {
  try {
    const response = await axiosInstance.get(
      "/battery/battery-ddl-existingsoldvehicles",
      {
        params: {
          dealer_id: dealerDropdown, // 👈 send here
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    const fetchedData = response?.data?.data?.data || response?.data?.data || [];
    const options = fetchedData.map((battery) => ({
      label: battery.NAME || battery.name,
      value: battery.ID || battery.id,
    }));

    setBatteryOptions(options);
  } catch (error) {
    console.error("Error fetching model options:", error);
  }
};

  const fetchBatteryName = async (batteryId, dealerDropdown) => {
    try {
      const payload = {
        dealer_id: dealerDropdown,
        batteryIdForBatteryName: batteryId,
      };

      const response = await axiosInstance.post(
        "/battery/battery-by-dealer",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((battery) => ({
        label: battery.NAME,
        value: battery.ID,
        batteryType: battery.batteryType,
      }));

      setBatteryNameOptions(options);
      const firstBatteryName = response?.data?.data?.data?.[0];
      setFirstBatteryNameOption(firstBatteryName?.ID || null);
      console.log(firstBatteryName, "firstBatteryName");
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    const batteryName = formData?.battery_name;
    if (batteryName) {
      fetchBatteryNo(batteryName);
    }
  }, [formData.battery_name]);

  const fetchBatteryNo = async (batteryName) => {
    try {
      const payload = {
        dealer_id: dealer_id,
        batteryId: batteryName,
      };

      const response = await axiosInstance.post(
        "/battery/battery-by-dealer",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((battery) => ({
        label: battery.NAME,
        value: battery.ID,
      }));

      setBatteryNumbersOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  // useEffect(() => {
  //   const vinId = formData.vin_no;

  //   if (vinId) {
  //     fetchVinData(vinId);
  //   }
  // }, [formData.vin_no]);

  // const fetchVinData = async (vinId) => {
  //   try {
  //     const response = await axiosInstance.get(`/sales/vin-details/${vinId}`, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });

  //     const fetchedData = response?.data?.data[0];

  //     setFormData((prevData) => ({
  //       ...prevData,
  //       tax_percent: fetchedData.tax_percent,
  //       baseprice: fetchedData.baseprice,
  //       taxamount: fetchedData?.taxamount,
  //       totalamount: fetchedData?.totalamount,
  //       downPayment: fetchedData?.totalamount,
  //     }));
  //   } catch (error) {
  //     console.error("Error fetching model options:", error);
  //   }
  // };

  // const handleMailFunc = async () => {
  //   const encoded = base64.encode(customerId);

  //   try {
  //     const response = await axiosInstance.get(
  //       `/purchaseorder/attchement-send-emailto-customer/${encoded}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       await showAlert({
  //         title: "Success",
  //         text: "Email sent successfully.",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //     }

  //   } catch (error) {
  //     console.error("Error fetching action taken list:", error);
  //   }
  // };

  // const handleMailFunc = async (id) => {
  //   const encoded = base64.encode(id.toString()); // Ensure it's a string

  //   try {
  //     const response = await axiosInstance.get(
  //       `/purchaseorder/attchement-send-emailto-customer/${encoded}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       await showAlert({
  //         title: "Success",
  //         text: "Email sent successfully.",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error sending email:", error);
  //   }
  // };

  // const handleMailFunc = async (id) => {
  //   if (id === undefined || id === null) {
  //     console.error("Customer ID is missing for email.");
  //     return;
  //   }
  //   const encoded = base64.encode(id.toString());

  //   try {
  //     const response = await axiosInstance.get(
  //       `/purchaseorder/attchement-send-emailto-customer/${encoded}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       },
  //     );

  //     if (response.status === 200) {
  //       await showAlert({
  //         title: "Success",
  //         text: "Email sent successfully.",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error sending email:", error);
  //   }
  // };

  useEffect(() => {
    fetchTableList();
  }, []);

  // fetching table data
  const fetchTableList = async (page = 0, pageSize = 10) => {
    try {
      // setLoading(true)
      const response = await axiosInstance.get(
        "/customer-po/draft",
        // {
        //   orderBy: "po_draft_id desc",
        //   page,
        //   pageSize,
        // },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const formattedData = response?.data?.data?.drafts?.map(
        (item, index) => ({
          ...item,
          "Sr No.": index + 1 + page * pageSize,
          variant_name: item.variant_name || "--",
          // productimage: item.productimage || "--",
          part_category_name: item.part_category_name || "--",
          job_card_number: item.job_card_number || "--",
          battery_no: Array.isArray(item.battery_no)
            ? item.battery_no.join(", ")
            : item.battery_no || "--",
        }),
      );

      const fetchedData = response?.data?.data?.payment_details;

      setFormData((prevData) => ({
        ...prevData,
        // tax_percent: fetchedData.tax_percent,
        // baseprice: fetchedData.taxamount,
        taxamount: fetchedData?.taxamount,
        totalamount: fetchedData?.totalamount,
        downPayment: fetchedData?.totalamount,
      }));

      setProductData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      // setLoading(false)
    }
  };

  useEffect(() => {
    // const dealerDropdown = formData.select_dealer;
      //  if (selected) {
        fetchDealers();
      // }
  }, []);
  const fetchDealers = async () => {
      try {
        const response = await axiosInstance.post("/dealer/ddldealer", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
  
        const data = response?.data?.data?.data;
  
        const dealerOptions = data.map((dealer) => ({
          value: dealer.dealer_id,
          label: dealer.dealer_name,
        }));
  
        setDealerOptions(dealerOptions);
      } catch (error) {
        console.log(error);
      }
    };


  const TABLE_HEADERS = [
    // "PO Draft No.",
    // "Variant Name",
    // "Color",
    "Item Name",
    "Vin No.",
    // "ProductImage",
    // "Item Type",
    // "Category Name",
    // "Quantity",
    "Battery No.",
    "Rate (₹)",
    "Tax (%)",
    // "Variant Remark",
    "Tax Amount (₹)",
    "Total Amount (₹)",
    // "Job Card Number",
    "Action",
  ];

  const keyMapping = {
    "PO Draft No.": "podraft_number",
    "Vin No.": "vin_no",
    "Variant Name": "NAME",
    "Battery No.": "battery_no",
    Color: "color_name",
    "Item Name": "item_name",
    ProductImage: "productimage",
    "Item Type": "itemtype_name",
    "Category Name": "part_category_name",
    Quantity: "quantity",
    "Rate (₹)": "baseprice",
    "Tax (%)": "tax_percent",
    "Variant Remark": "variant_remark",
    "Tax Amount (₹)": "taxamount",
    "Total Amount (₹)": "totalamount",
    "Job Card Number": "job_card_number",
    Action: [
      // { type: "edit", icon: editIcon, label: "Edit" },
      { type: "delete", icon: deleteIcon, label: "Delete" },
    ],
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleDelete = async (rowData) => {
    console.log("clicked", rowData);
    try {
      let selectedVinOption;
      if (formData.itemType === "V") {
        selectedVinOption = vinOptions.find(
          (option) => option.value === formData.vin_no,
        );
      } else if (formData.itemType === "A" || formData.itemType === "S") {
        selectedVinOption = serialNoOptions.find(
          (option) => option.value === formData.vin_no,
        );
      }

      const response = await axiosInstance.post(
        `/customer-po/deletedraft`,
        {
          vin_no: rowData?.vin_no,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      if (response.status === 200) {
        console.log("Item deleted successfully");
        fetchTableList();
      } else {
        console.error("Failed to delete item");
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2">
            <img src={backicon} alt="back"  onClick={() => navigate(-1)}/>
            <span className="backbtntitle">Add Orders</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Add Customer Details
            </span>
            <DynamicForm
              formConfig={DealerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
            <div className="btncontainer mt-3">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn"
              >
                Submit
              </button>
            </div>

            {/* <span className="cust-det-title mt-2 mb-2">Add Item Details</span> */}
            {/* <DynamicForm
              formConfig={ItemInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            /> */}

            {/* <div
              style={{
                display: "flex",
                justifyContent: "end",
                gap: "15px",
                paddingTop: "20px",
                alignItems: "center",
              }}
            >
              <button
                // onClick={() => { handleClaimSubmit(formData)}}
                className="clear-btn"
                style={{ paddingLeft: "35px", paddingRight: "35px" }}
                onClick={() =>
                  setFormData((prev) => ({ ...prev, ...clearItemFields() }))
                }
              >
                Reset Item Details
              </button>
              <button
                className="submitt-btn"
                onClick={() => {
                  handleFormSave(formData);
                }}
              >
                Save Item Details
              </button>
            </div> */}
            {/* <span className="cust-det-title mt-2 mb-2">
              Add Payment Details
            </span>
            <DynamicForm
              formConfig={FinanceInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            /> */}
            {/* <DynamicForm
              formConfig={RSAInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            /> */}
          </div>
          {/* 
          <div>
            <CustomTable
              data={productData}
              headers={TABLE_HEADERS}
              keyMapping={keyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              // onEdit={handleEdit}
              isADDcomplainTable={true}
              totalRecords={totalRecords}
              handleDelete={handleDelete}
            />
          </div> */}

          {/* <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div> */}
        </>
      )}
    </>
  );
};

export default SoldAddPurchaseOrder;
